import { base } from '@service/base';

import { CouponDigital } from 'src/models';

export async function getDigitalCouponById(
  couponId: number
): Promise<CouponDigital.IDigitalCoupon> {
  try {
    const { data } = await base.get<CouponDigital.IDigitalCoupon>(
      `/coupon/${couponId}`
    );
    return data;
  } catch (error) {
    throw new Error('Não foi possível carregar o cupom solicitado!');
  }
}
